import React from 'react';

export default () => <svg width="100px" height="100px"
    viewBox="0 0 100 100" >
    <path class="ui_icon__fill" d="M42.81 50l0 -10.95 9.49 5.48 9.48 5.47 -9.48 5.47 -9.49 5.48 0 -10.95zm34.68 -22.37l-54.98 0c-3.8,0 -6.9,3.1 -6.9,6.9l0 30.94c0,3.8 3.1,6.9 6.9,6.9l54.98 0c3.8,0 6.9,-3.1 6.9,-6.9l0 -30.94c0,-3.8 -3.1,-6.9 -6.9,-6.9z"/>
</svg>